<template>
  <div v-if="!isDesign" class="ds-control ds-label-box pc" :class="getCss" :style="getStyle">
    <template v-if="hasHelper && dataCapionTarget == 'text'">
      <el-popover v-if="dataCapionType == 'hoverPop' || dataCapionType == 'clickPop'" class="ds_label-helper" placement="top" title="" width="200" :trigger="dataCapionType == 'hoverPop' ? 'hover' : 'click'">
        <span slot="reference" class="text" :style="{color: realColor}">{{ value }}</span>
        <div v-html="dsf.safe.xss(dataCapion)"></div>
      </el-popover>
      <span v-else class="text" :style="{color: realColor}" @click="showHelper">{{ value }}</span>
    </template>
    <span v-else class="text" :style="{color: realColor}">{{ value }}</span>
    <slot name="helper">
      <template v-if="hasHelper && dataCapionTarget == 'icon'">
        <el-popover v-if="dataCapionType == 'hoverPop' || dataCapionType == 'clickPop'" class="ds_label-helper" placement="top" title="" width="200" :trigger="dataCapionType == 'hoverPop' ? 'hover' : 'click'">
          <i slot="reference" class="iconfont icon-bangzhuzhongxin"></i>
          <div v-html="dsf.safe.xss(dataCapion)"></div>
        </el-popover>
        <i v-else class="iconfont icon-bangzhuzhongxin ds_label-helper" @click="showHelper"></i>
      </template>
    </slot>
  </div>
  <div v-else-if="!editting" class="ds-control ds-label-box pc" :class="getCss" :style="getStyle" @dblclick="beginEdit">
    <span class="text" :style="{color: realColor}">{{ value || "无内容" }}</span>
    <slot name="helper">
      <i v-if="dataCapion && dataCapionTarget == 'icon'" class="iconfont icon-bangzhuzhongxin ds_label-helper"></i>
    </slot>
  </div>
  <div v-else class="ds-control ds-label-box pc" :class="getCss" :style="getStyle" :editting="editting">
    <el-input ref="contenteditable" v-model="value" :style="{color: realColor}" type="textarea" autosize placeholder="请输入内容" resize="none" @blur="endEdit" />
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfLabel",
  mixins: [$mixins.text],
  inheritAttrs: false,
  ctrlCaption: "文本",
  props: {
    value: {
      type: [String, Number],
      default: "文本标签"
    },
    // 是否块级元素
    isBlock: {
      type: Boolean,
      default: true
    },
    // 行高
    height: {
      type: String,
      default: ""
    },
    // 字体
    fontFamily: {
      type: String,
      default: ""
    },
    fontType: {
      type: [Number, String],
      default: ""
    },
    // 文字居中/居左/居右
    textAlign: {
      type: String,
      default: ""
    },
    // 是否只显示一行（废弃）
    // oneLine: {
    //   type: Boolean,
    //   default: false,
    // },
    // 最多显示几行（0表示无限制）
    ellipsis: {
      type: Number,
      default: 0
    },
    // 是否加粗
    isBold: {
      type: Boolean,
      default: false
    },
    // 是否斜体
    isItalic: {
      type: Boolean,
      default: false
    },
    //是否显示必填*号
    required: {
      type: Boolean,
      default: false
    },
    forFormControl: {
      type: String,
      default: ""
    },
    isOnce: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editting: false
    };
  },
  computed: {
    getCss() {
      const res = this.$getClass();
      if (this.textAlign) res.push("text-" + this.$textAlign);
      if (this.fontFamily) res.push("ds_font_" + this.fontFamily);
      if (this.isBold) res.push("ds-bold");
      if (this.isItalic) res.push("ds-italic");
      if (this.$attrs["oneLine"] || this.ellipsis === 1) {
        res.push("ellipsis");
      } else if (this.ellipsis > 1) {
        res.push("ellipsis-2");
      }
      if (this.fontType) {
        res.push("ds-font" + this.fontType);
      }
      if (!this.editting) {
        if (this.required) {
          res.push("ds-required");
        }
      }
      return res;
    },
    getStyle() {
      let res = {};
      if (!this.isBlock) {
        res["display"] = "inline-block";
      }
      if (this.height) {
        res["line-height"] = this.height;
      }
      if (this.ellipsis > 1) {
        res["-webkit-line-clamp"] = this.ellipsis;
      }
      return res;
    },
    hasHelper() {
      return !!this.dataCapion;
    },
    $textAlign: {
      get() {
        //以前老版本的值是text-开头，比如text-center，但这样的字符不太友好，改为center,left,right
        let align = this.textAlign || "left";
        if (align.startsWith("text-")) {
          align = align.replace("text-", "");
        }
        return align;
      },
      set(v) {
        let align = v || "left";
        if (align.startsWith("text-")) {
          align = align.replace("text-", "");
        }
        this.$emit("update:textAlign", align);
      }
    }
  },
  methods: {
    beginEdit() {
      if (this.isDesign) {
        this.editting = true;
        this.__startValue = this.value;
        this.$nextTick(() => {
          // alert(this.$refs.contenteditable)
          window.setTimeout(() => {
            this.$refs.contenteditable && this.$refs.contenteditable.focus();
          }, 100);
        });
      }
    },
    endEdit(e) {
      if (this.isDesign) {
        this.editting = false;
        let v = e.target.value;
        if (this.__startValue != v) {
          // 记录页面修改
          this.$designer.recordPageChange();
        }
      }
    }
  },
  watch: {
    value: {
      handler(v, ov) {
        if (this.isDesign && v != ov && this.attach) {
          this.$eventBus.$emit("des-lable-value-change", this);
        }
      }
    }
  }
});
</script>